"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarNeoDark = exports.calendarNeoLight = exports.calendarNovoDark = exports.calendarNovo = exports.calendar = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const calendar = {
    fontFamily: font_const_1.default.family,
    fontSize: font_const_1.default.sizeSm,
    lineHeight: font_const_1.default.lineHeightXs,
    daySize: '2.5rem',
    dayFontSize: font_const_1.default.sizeSm,
    dayColor: color_const_1.default.pickledBluewood800,
    daySelectedColor: color_const_1.default.white,
    dayPassiveColor: color_const_1.default.cloudyBlue,
    dayDisabledColor: color_const_1.default.cloudyBlue300,
    dayBackground: 'transparent',
    daySelectedBackground: color_const_1.default.dodgerBlue,
    daySelectedDisabledBackground: color_const_1.default.dodgerBlue300,
    dayPreviewBorderWidth: size_const_1.default.borderSizeDefault,
    dayPreviewBorderStyle: 'solid',
    dayPreviewBorderColor: color_const_1.default.dodgerBlue300,
    todayLineColor: color_const_1.default.dodgerBlue300,
    todaySelectedLineColor: color_const_1.default.white,
    todayLineWidth: size_const_1.default.default2x,
    todayLineHeight: size_const_1.default.smallest,
    weekDaysMarginBottom: spacing_const_1.default.xxs,
    weekDaysBorderWidth: size_const_1.default.borderSizeDefault,
    weekDaysBorderStyle: 'solid',
    weekDaysBorderColor: color_const_1.default.cloudyBlue300,
    weekDayColor: color_const_1.default.steel700,
    monthNameFontSize: font_const_1.default.sizeMd,
    monthNameLineHeight: font_const_1.default.lineHeightMd,
    monthNameFontWeight: font_const_1.default.weightAttention,
    calendarBackground: 'transparent',
    calendarHorizontalPadding: spacing_const_1.default.xs,
    calendarMonthYearPickerBottomMargin: spacing_const_1.default.lg,
    calendarMonthYearPickerVerticalPadding: spacing_const_1.default.sm,
    monthSeparatorLineWidth: '1px',
    monthSeparatorLineColor: color_const_1.default.cloudyBlue300,
    monthSeparatorLineMargin: spacing_const_1.default.md,
    monthColor: undefined,
    lineBorderRadius: undefined,
    daySelectedEdgeBackground: undefined,
    daySelectedEdgeColor: undefined,
    dayPreviewBackground: 'transparent',
    arrowColor: undefined,
    isClassic: true,
};
exports.calendar = calendar;
const todayTypography = light.bodyBold01;
const weekdaysTypography = light.label01;
const numbersTypography = light.body01;
const monthYearTypography = light.body01;
const calendarNovo = {
    isClassic: false,
    // Typography
    fontFamily: undefined,
    fontSize: undefined,
    lineHeight: undefined,
    dayFontSize: undefined,
    monthNameFontSize: undefined,
    monthNameLineHeight: undefined,
    monthNameFontWeight: undefined,
    todayTypography,
    weekdaysTypography,
    numbersTypography,
    monthYearTypography,
    // Structure
    daySize: '2.5rem',
    dayPreviewBorderWidth: 0,
    dayPreviewBorderStyle: 'solid',
    todayLineWidth: '4px',
    todayLineHeight: '4px',
    lineBorderRadius: '50%',
    weekDaysBorderStyle: undefined,
    weekDaysMarginBottom: undefined,
    weekDaysBorderWidth: undefined,
    calendarHorizontalPadding: light.spacing03,
    calendarMonthYearPickerBottomMargin: light.spacing06,
    calendarMonthYearPickerVerticalPadding: light.spacing04,
    monthSeparatorLineMargin: light.spacing05,
    monthSeparatorLineWidth: undefined,
    // Colors
    arrowColor: light.icon01,
    dayColor: light.textColor01,
    daySelectedColor: light.textColor01,
    dayPassiveColor: light.disabled02,
    dayDisabledColor: light.disabled02,
    daySelectedEdgeColor: light.textColor06,
    dayBackground: undefined,
    daySelectedBackground: light.ui05,
    daySelectedEdgeBackground: light.action04,
    daySelectedDisabledBackground: light.ui05,
    dayPreviewBorderColor: light.hover06,
    dayPreviewBackground: light.hover06,
    todayLineColor: light.icon01,
    todaySelectedLineColor: light.icon02,
    weekDaysBorderColor: undefined,
    weekDayColor: light.textColor02,
    monthColor: light.textColor01,
    monthSeparatorLineColor: undefined,
    calendarBackground: light.ui06,
};
exports.calendarNovo = calendarNovo;
const calendarNovoDark = {
    ...calendarNovo,
    arrowColor: dark.icon01,
    dayColor: dark.textColor01,
    daySelectedColor: dark.textColor01,
    dayPassiveColor: dark.disabled02,
    dayDisabledColor: dark.disabled02,
    daySelectedEdgeColor: dark.textColor06,
    dayBackground: undefined,
    daySelectedBackground: dark.ui05,
    daySelectedEdgeBackground: dark.action04,
    daySelectedDisabledBackground: dark.ui05,
    dayPreviewBorderColor: dark.hover06,
    dayPreviewBackground: dark.hover06,
    todayLineColor: dark.icon01,
    todaySelectedLineColor: dark.icon02,
    weekDaysBorderColor: undefined,
    weekDayColor: dark.textColor02,
    monthColor: dark.textColor01,
    monthSeparatorLineColor: undefined,
    calendarBackground: dark.ui06,
};
exports.calendarNovoDark = calendarNovoDark;
const calendarNeoLight = {
    ...calendarNovo,
    arrowColor: neoLight.icon01,
    dayColor: neoLight.textColor01,
    daySelectedColor: neoLight.textColor01,
    dayPassiveColor: neoLight.disabled02,
    dayDisabledColor: neoLight.disabled02,
    daySelectedEdgeColor: neoLight.textColor06,
    daySelectedBackground: neoLight.ui05,
    daySelectedEdgeBackground: neoLight.action04,
    daySelectedDisabledBackground: neoLight.ui05,
    dayPreviewBorderColor: neoLight.hover06,
    dayPreviewBackground: neoLight.hover06,
    todayLineColor: neoLight.icon01,
    todaySelectedLineColor: neoLight.icon02,
    weekDayColor: neoLight.textColor02,
    monthColor: neoLight.textColor01,
    calendarBackground: neoLight.ui06,
};
exports.calendarNeoLight = calendarNeoLight;
const calendarNeoDark = {
    ...calendarNovoDark,
    arrowColor: neoDark.icon01,
    dayColor: neoDark.textColor01,
    daySelectedColor: neoDark.textColor01,
    dayPassiveColor: neoDark.disabled02,
    dayDisabledColor: neoDark.disabled02,
    daySelectedEdgeColor: neoDark.textColor06,
    daySelectedBackground: neoDark.ui05,
    daySelectedEdgeBackground: neoDark.action04,
    daySelectedDisabledBackground: neoDark.ui05,
    dayPreviewBorderColor: neoDark.hover06,
    dayPreviewBackground: neoDark.hover06,
    todayLineColor: neoDark.icon01,
    todaySelectedLineColor: neoDark.icon02,
    weekDayColor: neoDark.textColor02,
    monthColor: neoDark.textColor01,
    calendarBackground: neoDark.ui06,
};
exports.calendarNeoDark = calendarNeoDark;
